import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksProducts: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS,
	},
	getOrderGeneratorsFieldsWorksProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
	},
	createOrderGeneratorsFieldsWorksProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
	},
	putOrderGeneratorsFieldsWorksProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
	},
	patchOrderGeneratorsFieldsWorksProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
	},
	deleteOrderGeneratorsFieldsWorksProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT,
	},
}
